import React from "react"
import PropTypes from "prop-types"
class LoadingSpinner extends React.Component {
  render () {
    return (
      <React.Fragment>
        <div className="ajax-spinner" role="status" aria-label="Loading Indicator"/>
      </React.Fragment>
    );
  }
}

export default LoadingSpinner
